/**
 * CircularList component.
 */
import Container from '@components/atoms/container/listAnimationContainer';
import useCircularList, { CircularListProps } from './useCircularList';

/**
 * Renders a circular list of items with keyboard navigation and sliding animation.
 * @param props - Props for the CircularList component.
 * @returns {JSX.Element} The CircularList component.
 */
export default function CircularList<T>(props: CircularListProps<T>) {
  const { children, duration, index, onTransitionEnd } = useCircularList(props);
  if (!props.items.length) return null;
  return (
    <Container
      direction={props.direction}
      duration={duration}
      index={index}
      offset={props.offset}
      onTransitionEnd={onTransitionEnd}
    >
      {children}
    </Container>
  );
}
